// src/services/citiesApi.ts
import { api } from './baseApi';
export var citiesApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            // Получение всех городов
            getCities: builder.query({
                query: function () {
                    return ({
                        url: '/cities',
                        method: 'GET',
                    });
                },
                providesTags: ['Cities'],
            }),
            // Получение только городов России
            getRussianCities: builder.query({
                query: function () {
                    return ({
                        url: '/cities/russia',
                        method: 'GET',
                    });
                },
                providesTags: ['Cities'],
            }),
            deleteCity: builder.mutation({
                query: function (id) {
                    return ({
                        url: "/cities/".concat(id),
                        method: 'DELETE',
                    });
                },
                invalidatesTags: ['Cities'],
            }),
            // Создание города
            createCity: builder.mutation({
                query: function (body) {
                    return ({
                        url: '/cities',
                        method: 'POST',
                        body: body,
                    });
                },
                invalidatesTags: ['Cities'],
            }),
            // Инициализация городов России
            initializeRussianCities: builder.mutation({
                query: function () {
                    return ({
                        url: '/cities/init/russia',
                        method: 'POST',
                    });
                },
                invalidatesTags: ['Cities'],
            }),
        });
    },
});
export var useGetCitiesQuery = citiesApi.useGetCitiesQuery, useGetRussianCitiesQuery = citiesApi.useGetRussianCitiesQuery, // ← ДОБАВЛЯЕМ
useDeleteCityMutation = citiesApi.useDeleteCityMutation, useCreateCityMutation = citiesApi.useCreateCityMutation, useInitializeRussianCitiesMutation = citiesApi.useInitializeRussianCitiesMutation;
